module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PENDING":"Pending applications","EXPIRING_OFFER":"Aging proposals"},"et":{"PENDING":"Pending applications","EXPIRING_OFFER":"Aging proposals"},"ru":{"PENDING":"Pending applications","EXPIRING_OFFER":"Aging proposals"}}')
  delete Component.options._Ctor
}
